import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { Button, Text } from 'components/styleguide';
import { useRootTranslation } from 'utils/hooks';

const rootT = 'drawers.tracksImportResolver';

type ResolverHeaderProps = {
  matched: number;
  total: number;
  onCancel: () => void;
  onFinish: () => void;
  finishDisabled?: boolean;
  matching?: boolean;
  showAllTracks?: boolean;
  onShowAllTracksChange?: (showAll: boolean) => void;
};

const ResolverHeader = ({
  matched,
  total,
  onCancel,
  onFinish,
  finishDisabled,
  matching,
  showAllTracks,
  onShowAllTracksChange,
}: ResolverHeaderProps) => {
  const t = useRootTranslation(rootT);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 4 }}>
      <Stack gap={1} sx={{ maxWidth: '60%' }}>
        <Text semibold variant="h4">
          {t(matching ? 'titleMatching' : 'title')}
        </Text>
        {/* The subtitle claims tracks went unmatched — unknowable until the match settles. */}
        {!matching && <Typography variant="caption">{t('subtitle')}</Typography>}
      </Stack>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {!matching && onShowAllTracksChange && (
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={Boolean(showAllTracks)}
                onChange={(event) => onShowAllTracksChange(event.target.checked)}
                inputProps={{ 'data-testid': 'tracks-import-resolver-show-all' } as never}
              />
            }
            label={
              <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                {t('showAllTracks')}
              </Typography>
            }
            sx={{ mr: 0 }}
          />
        )}
        {!matching && (
          <Typography variant="body2" sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
            {t('matchedCounter', { matched, total })}
          </Typography>
        )}
        <Button onClick={onCancel} size="sm" synchronous testId="tracks-import-resolver-cancel" variant="destructive">
          {t('cancel')}
        </Button>
        <Button
          disabled={finishDisabled}
          onClick={onFinish}
          size="sm"
          testId="tracks-import-resolver-finish"
          variant="primary"
        >
          {t('finishImport')}
        </Button>
      </Box>
    </Box>
  );
};

export default ResolverHeader;
